import { useAuth0 } from '@auth0/auth0-react';
import { CSSObject, Link, Tooltip } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink as RouterNavLink } from 'react-router-dom';

const activeStyles: CSSObject = {
  borderLeftColor: 'white',
};

interface Props {
  to: string;
  icon: IconProp;
  title: string;
}

function NavLink({ to, icon, title }: Props) {
  return (
    <Tooltip label={title} hasArrow placement="right" openDelay={500}>
      <Link
        as={RouterNavLink}
        to={to}
        display="block"
        textAlign="center"
        py={4}
        borderX="8px"
        borderColor="purple.500"
        _hover={activeStyles}
        sx={{ '&.active': { borderLeftColor: 'white' } }}
      >
        <FontAwesomeIcon icon={icon} color="white" size="lg" />
      </Link>
    </Tooltip>
  );
}

/* eslint-disable jsx-a11y/anchor-is-valid */
export function SignoutNavLink() {
  const { logout } = useAuth0();
  return (
    <Tooltip label="Sign out" hasArrow placement="right" openDelay={500}>
      <Link
        onClick={() => logout()}
        display="block"
        textAlign="center"
        py={4}
        borderX="8px"
        borderColor="purple.500"
        _hover={activeStyles}
        sx={{ '&.active': { borderLeftColor: 'white' } }}
      >
        <FontAwesomeIcon icon={['fal', 'sign-out']} color="white" size="lg" />
      </Link>
    </Tooltip>
  );
}
/* eslint-enable jsx-a11y/anchor-is-valid */

export default NavLink;
